// extracted by mini-css-extract-plugin
module.exports = {"audio":"media-audio_audio__2_ayK"};